import { ActionTypes, Status } from './actions';

const initialState = {
  dialogs: {
    shareAdvertiser: {
      status: Status.STATUS_CLOSE,
      value: null
    }
  }
};

export default function dialogStatusReducer(state = initialState, action) {
  const { STATUS_OPEN, STATUS_CLOSE } = Status;
  switch (action.type) {
    case ActionTypes.OPEN_DIALOG: {
      const { dialogName, value } = action.payload;
      return {
        ...state,
        dialogs: {
          [dialogName]: {
            status: STATUS_OPEN,
            value
          }
        }
      }
    }
    case ActionTypes.CLOSE_DIALOG: {
      const { dialogName, value } = action.payload;
      return {
        ...state,
        dialogs: {
          [dialogName]: {
            status: STATUS_CLOSE,
            value
          }
        }
      }
    }
    default:
      return state;
  }
}

export { namespace } from './actions';
